/**
 * 2019/1/10.
 * 作者:lzq
 * 功能: 系统管理请求路径
 */
import SYSDICCOMMS from './sysDicComms';
import SYSTEMOPERATION from './systemOperation';
import USERMANGEMENT from './userManagement';
import ECHARTMANGEMENT from './echartManagement';
import ROLEMANGEMENT from './roleManagement';
import ORGANIZATIONALMANAGEMENT from './organizationalManagement';
import RESOURCEMANGEMENT from './resourceManagement';
import FUNCTIONMANGEMENT from './functionManagement';
import TIMEWORK from './timeWork';
import DEPARTMANGEMENT from './departManagement';

export default {
  SYSDICCOMMS,
  SYSTEMOPERATION,
  USERMANGEMENT,
  ROLEMANGEMENT,
  ORGANIZATIONALMANAGEMENT,
  RESOURCEMANGEMENT,
  FUNCTIONMANGEMENT,
  ECHARTMANGEMENT,
  TIMEWORK,
  DEPARTMANGEMENT
};
